/**
@format
@flow
*/
import React from 'react';
import styled from 'styled-components';
import Headline from '@ziynx/components/headlines';
import type { Props as HeadlineDefaultType } from '@ziynx/components/headlines/HeadlineDefault';
import ListItem from '@ziynx/components/listItems';
import type { SquircleType as ListItemSquircleType } from '@ziynx/components/listItems';
import { Heading } from '@ziynx/components/typography';
import Icon from '@ziynx/components/icons';
import Colors from '@ziynx/theme/colors';
import CardBase from './CardBase';

export type Props = $ReadOnly<{|
    headline?: HeadlineDefaultType,
    data: Array<ListItemSquircleType>,
|}>;

const ComponentWrapper = styled.div`
    width: 288px;
    box-sizing: border-box;
`;

const StyledHeadline = styled(Headline)`
    padding-bottom: 24px;
`;

const StyledCardBase = styled(CardBase)`
    box-sizing: border-box;
`;

const ListItemWrapper = styled.div`
    padding-bottom: ${({ lastChild }) => (lastChild ? '0' : '24px')};
    cursor: pointer;
    :div {
      cursor: pointer;
    }
`;

const EmptyWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

const IconWrapper = styled.div`
    margin-bottom: 16px;
`;

const CardListItemSquircle = (props: Props): React$Node => {
  const {
    headline,
    data,
  } = props;

  const renderListItem = (item, index) => (
    <ListItemWrapper
      key={index + 1}
      lastChild={index === data?.length - 1}
    >
      <ListItem
        {...item}
        variant="squircle"
        size="medium"
      />
    </ListItemWrapper>
  );

  const renderEmpty = () => (
    <EmptyWrapper>
      <IconWrapper>
        <Icon
          name="profile-fill"
          size="small"
          color={Colors.GrayLight}
        />
      </IconWrapper>
      <Heading color={Colors.Gray}>
        List is empty
      </Heading>
    </EmptyWrapper>
  );

  return (
    <ComponentWrapper>
      <StyledHeadline {...headline} />
      <StyledCardBase width="288px">
        {data?.length ? data.map((item, index) => renderListItem(item, index)) : renderEmpty()}
      </StyledCardBase>
    </ComponentWrapper>
  );
};

export default CardListItemSquircle;
